module.exports = __webpack_public_path__ + "static/img/slide_9.8053686.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/consulting/slider/slide_9.png
// module id = THbO
// module chunks = 0